export default __webpack_public_path__ + "static/media/PlayIcon.314ab38d.webp";